// 用户
const USER = {
  login: { apiUrl: '/login', method: 'post' } // 登录
}
export default USER
